export const users = {
      title: 'Users',
      subtitle: 'Manage real invitations and organization access roles',
      invite: 'Invite user',
      emptyTitle: 'No access records to display',
      emptyDescription: 'There are no members or pending invitations matching the current filters.',
      searchPlaceholder: 'Search by email, name, or role',
      allStatuses: 'All statuses',
      active: 'Active',
      pending: 'Pending',
      blocked: 'Suspended',
      owner: 'Owner',
      admin: 'Admin',
      user: 'User',
      readOnly: 'Read only',
      totalVisible: 'Visible total',
      activeUsers: 'Active members',
      pendingUsers: 'Pending invitations',
      adminUsers: 'Admins',
      withFilters: 'With active filters',
      operational: 'With active access',
      requiresAction: 'Pending acceptance',
      withRealAccess: 'Real access enabled',
      inviteTitle: 'Send invitation',
      inviteSubtitle: 'Create a real backend invitation so the user can activate access when signing in.',
      inviteEmailHint: 'It must match the email the user will use in Microsoft Entra ID.',
      expiresInDays: 'Expires in days',
      expiresInDaysHint: 'Number of days before the invitation expires.',
      sendInvitation: 'Send invitation',
      pendingInvitation: 'Pending invitation',
      invitationReadyTitle: 'Invitation created',
      invitationReadyDescription: 'Access for {{email}} is ready. Share this link so the user can sign in.',
      copyAccessLink: 'Copy link',
      copyInvitationMessage: 'Copy message',
      revokeInvitation: 'Revoke invitation',
      revokeInvitationTitle: 'Revoke invitation',
      revokeInvitationSubtitle: 'This action will cancel the pending invitation for {{email}}.',
      revokeInvitationSubtitleFallback: 'This action will cancel the selected pending invitation.',
      revokeInvitationConfirm: 'Yes, revoke',
      copyLinkSuccess: 'The access link was copied.',
      copyMessageSuccess: 'The invitation message was copied.',
      copyFailed: 'Automatic copy failed. Please copy the link manually.',
      accessState: 'Access state',
      memberActiveState: 'Active access',
      memberSuspendedState: 'Suspended access',
      expiresOn: 'Expires on {{date}}',
      editRoleTitle: 'Update role',
      editRoleSubtitle: 'Update the organization role for {{email}}.',
      editRoleSubtitleFallback: 'Update the organization role for the selected user.',
      suspendUserTitle: 'Suspend user',
      suspendUserSubtitle: 'This action will suspend active access for {{email}}.',
      suspendUserConfirm: 'Yes, suspend',
      reactivateUserTitle: 'Reactivate user',
      reactivateUserSubtitle: 'This action will reactivate access for {{email}}.',
      reactivateUserConfirm: 'Yes, reactivate',
      toggleSuspensionSubtitleFallback: 'Confirm the access status update for this user.',
      invitationMessageTemplate: 'Hello. You already have access to Sunbrick ERP.\n\nSign in here:\n{{link}}\n\nYou must sign in with this email:\n{{email}}\n\nIf your invitation is still valid, access will be activated automatically after sign-in.',
    } as const;
